// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmActionModal_container__YMZgC","close":"ConfirmActionModal_close__1Zl4x"};